<template>
  <div class="app">
    <div class="m-viewport" id="mainView">

        <!-- <div class="cover">
            <video :src="'https://web-resource.17m3.com/m3guo/202601/he/banner.webm?v=' + randomKey" autoplay loop muted></video>
        </div> -->

        <div class="logo-view">
          <h2 class="logo_1 sprite sprite-logo"><a href="https://www.m3guo.com/v2/" target="_blank" rel="noopener noreferrer"></a></h2>
        </div>
        
        <div class="u-links">
            <div class="btn-index sprite sprite-btn-index">
                <a href="https://www.m3guo.com/v2/" target="_blank" rel="noopener noreferrer"></a>
            </div>
            <div class="btn-dl sprite sprite-btn-dl">
              <a href="https://www.m3guo.com/v2/download/client/" target="_blank" rel="noopener noreferrer"></a>
            </div>
        </div>
        
        <div class="u-btn copyright">
            <!-- todo -->
        </div>

        <div class="m-user">
            <user-info class="text-overflow-1"/>
        </div>
        
        <loading v-show="Loading"/>
     
        <div class="page-body">
            <div class="page-wrapper" v-if="ready">
                <invite data-aos="fade-up"/>
                <player data-aos="fade-up" style="margin-top: 236px;"/>
                <friends data-aos="fade-up" style="margin-top: 236px;"/>
                <patch data-aos="fade-up" style="margin-top: 236px;"/>
                <rule data-aos="fade-up" style="margin-top: 236px;"/>
            </div>
        </div>

    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'mainview',
    components: {
        loading: () => import('@/components/loading.vue'),
        invite: () => import('@/views/invite.vue'),
        player: () => import('@/views/player.vue'),
        friends : () => import('@/views/friends.vue'),
        patch : () => import('@/views/patch.vue'),
        rule : () => import('@/views/rule.vue')
    },
    data (){
        return {
            sns : false,
            randomKey : Math.random().toString(36).substring(2,8),
        }
    },
    computed : {
        ...mapState(['Loading'])
    },    
    props : {
        ready : {
            default : false,
        },
    },
    methods : {

    }, 
}
</script>

<style lang="scss" scoped>
.m-viewport{
    position: relative;
    width: 100%;
    margin: 0 auto 0;
    min-width: 1200px;
    max-width: 1920px;
    height: 7900px;
    padding-top: 830px;
    background-repeat: no-repeat;
    background-position: center top;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: hidden;
    background-image: url(~@/assets/images/pc/body.jpg);   
    z-index: 20;
    box-sizing: border-box;
    font-size: 16px;
    background-color: #1c1f1c;

    b{
        font-weight: 400;
        color: #26c7da;        
    }
}

.cover{
    position: absolute;
    left: 50%;
    top: -40px;
    width: 1920px;
    height: 1080px;
    transform: translateX(-50%);
    z-index: 5;

    video{
        width: 100%;
        height: 100%;
        object-fit: contain;
        border: none;
        mix-blend-mode: darken; 
    }

    video:focus {
        outline:none;
    }
}

.u-btn.invite{
    position: fixed;
    right: 2%;
    top: 30%;
    z-index: 10;
}

.logo-view{
    display: flex;
    align-items: center;
    position: absolute;
    left: 2%;
    top:30px;
    z-index: 10;
}

.logo-view a{
    display: block;
    width: 100%;
    height: 100%;
}

.u-links{
    display: flex;
    position: absolute;
    right: 4%;
    top: 30px;
    z-index: 6; 
    
    &>div{
        margin-left: 20px;
    }
}

.u-links a{
    display: block;
    width: 100%;
    height: 100%;
}

.page-body{
    position: relative;
    width: 100%;

}

.m-user{
    position: absolute;
    top: 800px;
    left: 50%;
    transform: translateX(-50%);
    width: 591px;
    height: 38px;
    line-height: 38px;
    margin: 0 auto;
    text-align: center;
    background-image: url(~@/assets/images/pc/bg-userinfo.png);
    z-index: 6;
}

.page-wrapper{   
    width: 1400px;
    margin: 270px auto 0;
}
</style>

<style lang="scss">
.view-data{
    font-size: 18px;
    font-weight: 700;
    color: #5b734f;

    b{
        font-size: 22px;
        color: #b98222;
    }
}
</style>